import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { createBenzo } from "@/lib/admin-substances.functions";
import { benzoInputSchema } from "@/lib/admin-substances.schemas";
import { CompoundForm, BENZO_FORM } from "@/components/admin/CompoundForm";

export const Route = createFileRoute("/_authenticated/_admin/admin/benzo/new")({
  component: NewBenzoPage,
});

function NewBenzoPage() {
  const navigate = useNavigate();
  const submit = useServerFn(createBenzo);
  const qc = useQueryClient();
  const [submitting, setSubmitting] = useState(false);

  return (
    <div style={{ padding: "2rem 1.5rem" }}>
      <CompoundForm
        config={BENZO_FORM}
        submitting={submitting}
        onCancel={() => navigate({ to: "/admin" })}
        onSubmit={async (values) => {
          const parsed = benzoInputSchema.safeParse(values);
          if (!parsed.success) {
            toast.error("Eingabe ungueltig", { description: parsed.error.issues.map(i => i.message).join("; ") });
            return;
          }
          setSubmitting(true);
          try {
            await submit({ data: parsed.data as any });
            toast.success("Benzo angelegt");
            qc.invalidateQueries({ queryKey: ["admin-substances"] });
            qc.invalidateQueries({ queryKey: ["public-benzos"] });
            navigate({ to: "/admin" });
          } catch (e: any) {
            toast.error("Speichern fehlgeschlagen", { description: e?.message ?? String(e) });
          } finally {
            setSubmitting(false);
          }
        }}
      />
    </div>
  );
}
